package music.jammers.shared.event.track.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.event.domain.model.EventMember
import music.jammers.shared.track.domain.model.Track
import music.jammers.shared.user.domain.model.User

@Serializable
data class EventTrack(
    val id: Long,
    val track: Track,
    val addedBy: User,
    val comment: String?,
    val backgroundInfo: EventTrackBackgroundInfo,
    val members: List<EventMember>,
) {

    val isReady: Boolean
        get() = members.all { item ->
            item.isReady
        }
}